import React, { useState } from "react";
import axios from "axios";

export default function CreateUserForm({ divisions }) {
  const roles = {
    8: "Администратор",
    4: "Сводящий",
    2: "Заведующий",
    1: "Адвокат",
  };

  const [formData, setFormData] = useState({
    realname: "",
    username: "",
    email: "",
    password: "",
    division_id: "",
    role_id: "", // Добавляем поле для выбора роли
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Обработчик изменения полей формы
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post("/settings/create_user", formData);
      setSuccess("Пользователь успешно создан!");
      setError(null);
      // Очистить форму
      setFormData({
        realname: "",
        username: "",
        email: "",
        password: "",
        division_id: "",
        role_id: "",
      });
    } catch (err) {
      if (err.response && err.response.data.errors) {
        // Берём ошибки из ответа сервера
        setError(err.response.data.errors.join(", "));
      } else {
        setError("Ошибка при создании пользователя. Попробуйте снова.");
      }
      setSuccess(null);
    }
  };

  return (
    <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold mb-6">Создать пользователя</h2>

      <form
        onSubmit={handleSubmit}
        className="space-y-6"
      >

        {error && <div className="text-red-600">{error}</div>}
        {success && <div className="text-green-600">{success}</div>}

        {/* Полное имя */}
        <div>
          <label className="block text-gray-700">Полное имя</label>
          <input
            type="text"
            name="realname"
            value={formData.realname}
            onChange={handleChange}
            required
            className="mt-1 block w-full border rounded p-2"
          />
        </div>

        {/* Имя пользователя */}
        <div>
          <label className="block text-gray-700">Имя пользователя</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            required
            className="mt-1 block w-full border rounded p-2"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mt-1 block w-full border rounded p-2"
          />
        </div>

        {/* Пароль */}
        <div>
          <label className="block text-gray-700">Пароль</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className="mt-1 block w-full border rounded p-2"
          />
        </div>

        {/* Селект для выбора отдела */}
        <div>
          <label className="block text-gray-700">Отдел</label>
          <select
            name="division_id"
            value={formData.division_id}
            onChange={handleChange}
            required
            className="mt-1 block w-full border rounded p-2 bg-white"
          >
            <option value="" disabled>
              Выберите отдел
            </option>
            {divisions.map((division) => (
              <option key={division.id} value={division.id}>
                {division.name.trim()}
              </option>
            ))}
          </select>
        </div>

        {/* Селект для выбора роли */}
        <div>
          <label className="block text-gray-700">Роль</label>
          <select
            name="role_id"
            value={formData.role_id}
            onChange={handleChange}
            required
            className="mt-1 block w-full border rounded p-2 bg-white"
          >
            <option value="" disabled>
              Выберите роль
            </option>
            {Object.entries(roles).map(([key, value]) => (
              <option key={key} value={key}>
                {value}
              </option>
            ))}
          </select>
        </div>

        {/* Кнопка отправки */}
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
        >
          Создать пользователя
        </button>
      </form>
    </div>
  );
}
